<!--
 * @Description: 富文本
 * @Author: mileS
 * @Date: 2020-06-10 16:40
 * @LastEditTime: 2020-06-10 16:40
 * @LastEditors: 2020-06-10 16:40
 -->
<template>
  <div class="protal-richtext-con">
    <div class="richtext-wrapper" v-html="richText"></div>
  </div>
</template>

<script>
export default {
  props: {
    richText: String
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
<style lang="scss">
.protal-richtext-con {
  margin-top: 20px;
  width: 100%;
  .richtext-wrapper {
    ul li{
      display: list-item;
      text-align: -webkit-match-parent;
      list-style: disc;
      }
    p {
      display: block;
      margin-block-start: 1em;
      margin-block-end: 1em;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
      margin-bottom: 1rem;
    }
    img {
      max-width: 100%;
    }
  }
}
</style>
